<template>
    <div class="content">
        <div class="section-header" :id="getUniqueIdForChart() + 'header'"><h2>Yhdistelmäkuvaaja</h2></div>
        <div class="add-combination-chart-bar">
            <div class="combination-add-inputs">
                <div>
                    <label for="combination-chart-left-values" style="color: #000;">Vasen y-akseli:</label>
                    <select
                            v-model="chosenLeftSelectOption"
                            id="combination-chart-left-values"
                            class="observation-value-select"
                            v-on:change="selectChange">
                        <option></option>
                        <option v-for="name in observationNames"
                                :value="name"
                        >{{name}}</option>
                    </select>
                </div>
                <div>
                    <label for="combination-chart-right-values" style="color: #000;">Oikea y-akseli:</label>
                    <select
                            v-model="chosenRightSelectOption"
                            id="combination-chart-right-values"
                            class="observation-value-select"
                            v-on:change="selectChange">
                        <option></option>
                        <option v-for="name in observationNames"
                                :value="name"
                        >{{name}}</option>
                    </select>
                </div>
            </div>
        </div>
        <canvas :id="getUniqueIdForChart()" style="max-height: 420px"></canvas>
    </div>
</template>

<script>
    export default {
        name: 'combination-charts-component',
        props: {
            observationNames: {},
            deviceId: null
        },
        data() {
            return {
                chosenLeftSelectOption: null,
                chosenRightSelectOption: null,
                showCombinationChart: false,
            }
        },
        methods: {
            selectChange() {
                this.showCombinationChart = false

                if (this.chosenLeftSelectOption && this.chosenRightSelectOption) {
                    this.showCombinationChart = true
                    let updateData = {
                        id: this.deviceId,
                        left: this.chosenLeftSelectOption,
                        right: this.chosenRightSelectOption,
                    }
                    this.$store.dispatch('setCombinationChartToUpdate', updateData)
                }
            },
            getUniqueIdForChart() {
                return 'combination-chart-' + this.deviceId
            }
        },
    }
</script>

<style>

    .add-combination-chart-bar {
        display: block;
        margin: auto;
        width: 40%;
    }
    .combination-add-inputs {
        display: flex;
        justify-content: space-around;

    }
    .observation-value-select {
        min-width: 90px;
    }

</style>



// WEBPACK FOOTER //
// src/app/Main/components/CombinationCharts.vue